import SetModelScreen from "./SetModelScreen";

export default SetModelScreen;